import React, { useState, useEffect } from "react";
import { Phone, Menu, X, Wrench, Instagram } from "lucide-react";
import { Button } from "./ui/button";
import { COMPANY, NAV_LINKS } from "../mock";

export default function Header({ onBookNow }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top utility bar */}
      <div className="hidden md:block bg-brand-dark text-white text-sm">
        <div className="max-w-7xl mx-auto px-6 py-2 flex justify-center items-center">
          <div className="flex items-center gap-6 text-white/85">
            <span>Available 24/7 – 365 Days</span>
            <span className="text-white/30">|</span>
            <span>Fully Licensed NSW Plumbers</span>
            <span className="text-white/30">|</span>
            <span>Servicing All Sydney Suburbs</span>
          </div>
        </div>
      </div>

      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur shadow-sm" : "bg-white"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <a href="#home" className="flex items-center gap-3">
            <img
              src="/assets/logo_transparent.png"
              alt="Cheerings Plumbing Group"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-slate-700 hover:text-[#0a4f8a] font-medium text-sm transition-colors relative after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-0 after:bg-sky-500 after:transition-all hover:after:w-full"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={`tel:${COMPANY.phoneLink}`}
              className="hidden md:flex items-center gap-2 text-[#0a4f8a] font-bold"
            >
              <div className="w-9 h-9 rounded-full bg-sky-100 flex items-center justify-center">
                <Phone size={16} className="text-sky-600" />
              </div>
              <span className="text-sm">{COMPANY.phone}</span>
            </a>
            <Button
              onClick={onBookNow}
              className="bg-sky-600 hover:bg-sky-700 text-white font-semibold px-5 shadow-md"
              data-testid="header-book-button"
            >
              Book Now
            </Button>
            <a
              href={COMPANY.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Follow us on Instagram ${COMPANY.instagramHandle}`}
              data-testid="header-instagram-link"
              className="hidden sm:inline-flex w-10 h-10 rounded-full items-center justify-center bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 text-white shadow-md hover:scale-105 transition-transform"
            >
              <Instagram size={18} />
            </a>
            <button
              className="lg:hidden p-2"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t bg-white">
            <div className="px-6 py-4 flex flex-col gap-3">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-slate-700 hover:text-[#0a4f8a] font-medium py-1"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </header>
    </>
  );
}
